// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import ShareHeader from './ShareHeader'
import SubscribeHeader from './SubscribeHeader'
import HeaderFrame from './HeaderFrame'
import { useSubscription } from '../../../hooks/subscriptions/queries';
import { useCurrentUser } from '../../../hooks/users/queries';
import { isCancelled, isOwner, isSeparatelyInvoiced } from '../../../utils/subscriptionUtils';

function SubscriptionHeaderFrame({
  children,
  dropdownOptions,
  hasEditPermission,
  isActive,
  name,
  projectId,
  roleIsEdit,
}){
  
  const { data: subscription } = useSubscription();
  const { data: currentUser } = useCurrentUser();
  const subscriptionIsCancelled = isCancelled(subscription);
  const subscriptionIsOwner = isOwner(subscription, currentUser?.id);

  // view only person
  if ( !roleIsEdit && !!isActive ) {
    return <ShareHeader
      hasEditPermission={hasEditPermission}
      projectID={projectId}
    >
      {name}
    </ShareHeader>
  }

  // cancelled person
  if ( subscriptionIsCancelled ) {
    return <SubscribeHeader
      isSubscriptionOwner={subscriptionIsOwner}
      isSeparatelyInvoiced={isSeparatelyInvoiced(subscription)}
      projectID={projectId}
    >
      {name}
    </SubscribeHeader>
  }

  // TODO: does this happen?
  if ( !hasEditPermission ) {
    return (
      <ShareHeader
        hasEditPermission={hasEditPermission}
        projectID={projectId}
      >
        {name}
      </ShareHeader>
    )
  }

  return (
    <HeaderFrame
      dropdownOptions={dropdownOptions}
      projectID={projectId}
      hasEditPermission={hasEditPermission}
      projectId={projectId}
    >
      {children}
    </HeaderFrame>
  );
}

export default SubscriptionHeaderFrame;
